<script>
import {mapState} from 'vuex'

export default {
  data:function(){
    return{
      breadcrumbs: [{
        text: 'Modules',
        to: {
          name: 'admin-modules'
        }
      },
      {
        text: 'Components',
        to: {
          name: 'admin-components'
        }
      },
      {
        text: 'Topics',
        to: {
          name: 'admin-topics'
        }
      },
      {
        text: 'Knowledge Check',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('topics', {
      topic: 'current'
    }),
    ...mapState('modules', {
      module: 'current'
    }),
    id(){
      return this.model ? this.model.id : (this.$route.params.id || null)
    },
    params(){
      return {tenantId : this.organization.id,topicId: this.topic.id}
    },
    paramsWithId(){
      return {tenantId : this.organization.id,topicId: this.topic.id, knowledgecheckId: this.id}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/kc-base.vue